const useDeleteCourse = (setCollectedData, deletedCourse, levelId) => {
  setCollectedData((prevState) => {
    const updatedLevels = prevState.levels.map((level) => {
      if (level.id === levelId) {
        return {
          ...level,
          courses: level.courses.filter(
            (courses) => courses.id !== deletedCourse.id
          ),
        };
      }
      return level;
    });

    return {
      ...prevState,
      levels: updatedLevels,
    };
  });
};

export default useDeleteCourse;
